import { render, staticRenderFns } from "./SmartzEventsChart.vue?vue&type=template&id=5644a896&"
import script from "./SmartzEventsChart.vue?vue&type=script&lang=js&"
export * from "./SmartzEventsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports